export function intersect(leftArray, rightArray) {
    return leftArray.filter(value => rightArray.indexOf(value) > -1);
}

export const SORT_DOWN = "down";
export const SORT_UP = "up";

export function sortWithDirection(anArray, compareFunction, direction = SORT_UP) {
    return anArray.sort((anElem, anotherElem) => {
        if (direction === SORT_UP) {
            return compareFunction(anElem, anotherElem)
        } else {
            return compareFunction(anElem, anotherElem) * -1;
        }
    });
}

export function compareByPosition(anArray, anotherArray) {
    const a = anArray ?? [];
    const b = anotherArray ?? [];
    for (let i = 0; i < Math.min(a.length, b.length); i++) {
        if (a[i] < b[i]) {
            return -1;
        } else if (a[i] > b[i]) {
            return 1;
        }
    }

    return 0;
}